import { useState } from "react";
import axios from "axios";
import PaymentFailure from "./PaymentFailure";

export default function KalPopup({ show, onClose }) {
    const [currentStep, setCurrentStep] = useState('content');
    const [statusMessage, setStatusMessage] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    if (!show) return null;
    const Url=`/member/dues/createRecurring/ADVOCACY/SELF`

    const nextYear = new Date().getFullYear() + 1;
 const ToPay = async () => {
      setIsLoading(true);
      try {
        const response = await axios.get(`${Url}`, {
          headers: { 'Content-Type': 'application/json' }
        });

        if (response?.status === 200) {
          const data = response?.data;
          if (typeof data === 'string') {
            // getTrainingDays();
            // onNext(data);
          } else if (response?.data?.urlPage) {
            window.location.href = response?.data?.urlPage;
          } else {
            setStatusMessage('קשה לעסקה עם שרת התשלום');
            setCurrentStep('error');
          }
        } else {
          setStatusMessage(response.response?.data?.message || 'שגיאה בתשלום');
          setCurrentStep('error');
        }
      } catch (error) {
        setStatusMessage(
          error?.response?.data?.message || 'שגיאה בתשלום, אנא נסה שוב'
        );
        setCurrentStep('error');
      } finally {
        setIsLoading(false);
      }
    };

    if (currentStep === 'error') {
        return (
            <PaymentFailure
                onClose={() => setCurrentStep('content')}
                error={statusMessage}
                titlerror="התשלום נכשל"
            />
        );
    }

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black/40 backdrop-blur-sm z-50 px-4" dir="rtl">
            <div className="bg-white rounded-xl shadow-lg my-4 overflow-y-scroll max-h-[80vh] w-full max-w-md p-6 relative animate-fadeIn">

                {/* Close */}
                <button
                    onClick={onClose}
                    className="absolute top-3 right-3 text-gray-500 hover:text-gray-700"
                >
                    ✕
                </button>

                {/* Title */}
                <h2 className="text-lg font-bold text-gray-800 text-center mb-3">
                    הקרן לסיוע הדדי (קל"ה)
                </h2>

                {/* Body */}
                <p className="text-gray-600 text-sm leading-relaxed mb-5 text-center">
                    לשכת ממוני הבטיחות מזמינה אותך,
                    <br />
                    להצטרף ולהיות חבר/ה בקל"ה
                    
                    

                    {/* התוקף עד <strong>ינואר {nextYear}</strong>. */}
                </p>
                <ul className="text-gray-600 text-sm mb-5 space-y-1 text-right">
                    {/* <li>✔ הנחות לממוני בטיחות פעילים</li>
          <li>✔ תוקף עד ינואר של השנה העוקבת</li>
          <li>✔ רישום מהיר לקורסים ולימי הדרכה</li>
          <li>✔ שמירת סטטוס פעיל במערכת</li> */}
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            קרן לסיוע הדדי (קל"ה) מיסודה של עמותת לשכת ממוני הבטיחות בישראל
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            מסייעת לחברים להתמודד עם השלכות משפטיות של מימון עורך דין בהליך פלילי
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            החברות בקרן הינה לשנה קלנדרית בלבד ותקפה עד 31 בחודש דצמבר לאותה שנה
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            הוראת קבע פעילה תאפשר את תשלום דמי החברות בקל"ה באופן אוטומטי ותסייע בשמירה על רצף זכאות למקרה הצורך
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                   הוראת הקבע בגין דמי החברות מתחדשת אוטומטית בחודש ינואר בכל שנה
                        הקלנדרית הבאה - כל עוד הוראת הקבע תקינה         
                        </span>
                    </li>
                    <li className="flex items-start gap-2 justify-end">
                        <span className="text-green-500 ">✔</span>
                        <span>
                            הפעלת סיוע הקרן בהתאם לתנאים המפורטים בנוהל 009 של העמותה
                        </span>
                    </li>
                    {/* <li>✔ קרן לסיוע הדדי (קל"ה) מיסודה של עמותת לשכת ממוני הבטיחות בישראל</li>
                    <li>✔מסייעת לחברים להתמודד עם השלכות משפטיות של מימון עורך דין בהליך פלילי</li>
                    <li>✔ החברות בקרן הינה לשנה קלנדרית בלבד ותקפה עד 31 בחודש דצמבר לאותה שנה</li>
                    <li>✔ הוראת קבע פעילה תאפשר את תשלום דמי החברות בקל"ה באופן אוטומטי ותסייע בשמירה על רצף זכאות למקרה הצורך</li>
                    <li>✔ הוראת הקבע בגין דמי החברות מתחדשת אוטומטית בחודש ינואר בכל שנה
                        הקלנדרית הבאה - כל עוד הוראת הקבע תקינה.</li>
                    <li>✔ הפעלת סיוע הקרן בהתאם לתנאים המפורטים בנוהל 009 של העמותה</li> */}
                </ul>
                <p className="text-gray-700 text-sm text-center leading-relaxed mb-1">
                    "ביחד נעשה ונצליח"
                    <br />
                    בברכה
                    <br />
                    לשכת ממוני הבטיחות - מקצוענים זה אנחנו
                </p>
                {/* CTA */}
                <button
                    onClick={ToPay}
                    disabled={isLoading}
                    // onClick={() => window.location.href = "/api/member/dues/createRecurring/ADVOCACY/SELF"}
                    className="w-full bg-blue-600 text-white py-2 rounded-lg font-semibold hover:bg-blue-700 transition shadow-md disabled:bg-gray-300"
                >
                    {isLoading ? 'מעבר לתשלום' : 'מעבר לתשלום'}
                </button>

                <button
                    onClick={onClose}
                    className="text-gray-500 text-xs underline mt-3 w-full text-center"
                >
                    לא עכשיו
                </button>

            </div>
        </div>
    );
}
